import React, { Component } from 'react';
import Copyright from '../common/copyright';
import { Container } from '@material-ui/core';
import header from "../../assets/images/registrationHeader.png";
import { withStyles } from '@material-ui/styles';
import ReactPlayer from 'react-player'
import Grid from '@material-ui/core/Grid';
import "./Player.css";

const styles = theme => ({

    root: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        backgroundImage: `url(${header})`,
        alignItems: 'center',
        backgroundPositionY: '-150px',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'auto',
        backgroundColor: "#fff"
    },
    footer: {
        marginTop: 'auto',
    },
    playerContainer: {
        marginTop: 'auto'
    },
    // playerWrapper: {
    //     position: 'relative',
    //     paddingTop: '56.25%',
    // },
    // reactPlayer: {
    //     position: 'absolute',
    //     top: 0,
    //     left: 0,
    // }

});

class YouTubePlayer extends Component {
    state = {
        youtubeLink: ""
    }
    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        const youtubeCode = urlParams.get('youtubeCode');
        console.log("youtubeCode", youtubeCode);
        this.setState({"youtubeLink":"https://www.youtube.com/watch?v="+youtubeCode});
        console.log("youtubeLink", this.state.youtubeLink);
    }

    render() {
        const { classes } = this.props;
        return (
            <div className={classes.root}>
                <Container component="main" maxWidth="sm" className={classes.playerContainer}>
                    <div className='player-wrapper'>
                        <ReactPlayer
                            width='100%'
                            height='100%'
                            controls={false}
                            loop={false}
                            playing
                            className='react-player'
                            url={this.state.youtubeLink}
                        />
                    </div>
                </Container>
                <footer className={classes.footer}>
                    <Container maxWidth="sm">
                        <Copyright />
                    </Container>
                </footer>
            </div >
        )
    }
}

export default withStyles(styles)(YouTubePlayer);


